import { render, staticRenderFns } from "./tenant-transfer.vue?vue&type=template&id=6825b429&scoped=true&"
import script from "./tenant-transfer.vue?vue&type=script&lang=tsx&"
export * from "./tenant-transfer.vue?vue&type=script&lang=tsx&"
import style0 from "./tenant-transfer.vue?vue&type=style&index=0&id=6825b429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6825b429",
  null
  
)

export default component.exports